import React from "react";
import parse from 'html-react-parser';
import { frontEndLogs } from '../../action/logs/frontEndLogs';
import { analyticsClickEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import PropTypes from 'prop-types';

export class UserNoteShowModal extends React.Component {

  delimiterAddedAmountField = (number) => {
    if (number !== undefined) {
      let numStr = number.toString();
      let integerPart = numStr.split('.')[0];
      let decimalPart = numStr.split('.')[1] || '';
      let formattedIntegerPart = '';
      let count = 0;
      // Iterate through the integer part in reverse and add commas
      for (let i = integerPart.length - 1; i >= 0; i--) {
        count++;
        formattedIntegerPart = integerPart[i] + formattedIntegerPart;
        if (count % 3 === 0 && i !== 0) {
          formattedIntegerPart = ',' + formattedIntegerPart;
        }
      }
      // Add decimal part if exists
      let formattedNumber = decimalPart ? formattedIntegerPart + '.' + decimalPart : formattedIntegerPart;
      return formattedNumber;
    }
  }

  stylingForSummaryPopupCheckBox = (isMobile) => {
    return isMobile ? 'ml-0 mt-5 application-checkBox' : ' applicationInputCheckbox';
  }

  render() {
    const {
      amountRequested,
      saveIncomeData,
      saveexpendituredata,
      DocumentAgreeLabel,
      AgreeLabel,
      contactDocumentAgree,
      allUserData,
      repayMentTerm,
      flxAgree_C,
      flxDocumentAgree_C,
      flxContactAgree_C,
      flxAgree_c_Error,
      flxDocumentAgree_c_Error,
      flxContactAgree_C_Error,
      checkBoxValidationForJustConfirm,
      handChange,
      analyticsCheckBoxClickEvent,
      applicationSubmit,
      handleAmendButtonlick,
      scrollToFirstSection
    } = this.props;
    return (
      <div className="modal fade model-error" id="userNoteShowModel" tabIndex="-1" data-keyboard="false" data-backdrop="static" aria-labelledby="userNoteShowModelLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <button
              type="button"
              aria-label="Close"
              data-dismiss="modal"
              className="close"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              onClick={() => {
                handleAmendButtonlick();
              }}
            >
              <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
            </button>
            <div className="modal-body p-0">
              <div className="logo">
                <img src="images/modal-logo.svg" alt="logo" className="img-fluid mb-2" />
              </div>
              <div className="heading text-center ">
                <h2 className='mb-0' style={{ fontFamily: "proxima-nova", fontWeight: "800" }}>Before you continue…</h2>
              </div>

              <div className='sub-header'>
                <p className=' text-wrap' style={{ color: '#212529', fontFamily: "Proxima Nova, sans-serif" }}>
                  Please ensure that the below information is correct before you submit.
                </p>
              </div>

              <div className="label-container">
                <div className="label-column">
                  {(amountRequested !== undefined && amountRequested !== '') &&
                    <div className="label-item">
                      <h4>Loan Amount:</h4>
                      <span>£{this.delimiterAddedAmountField(amountRequested)}</span>
                    </div>
                  }
                  {allUserData['Loan_Term_Requested__c'] !== '' &&
                    <div className="label-item">
                      <h4 className='repayment-label'>Repayment Plan:</h4>
                      <span id='repaymentPlan'>{repayMentTerm}</span>
                    </div>
                  }


                </div>
                <div className="label-column">
                  {saveIncomeData !== '' &&
                    <div className="label-item">
                      <h4>Net Monthly Income:</h4>
                      <span>£{this.delimiterAddedAmountField(saveIncomeData)}.00</span>
                    </div>
                  }
                  {saveexpendituredata !== "" &&
                    <div className="label-item">
                      <h4>Total Monthly Expenses:</h4>
                      <span>£{this.delimiterAddedAmountField(saveexpendituredata)}.00</span>
                    </div>
                  }
                </div>

              </div>

              <div className={this.stylingForSummaryPopupCheckBox()}>
                <div className='form-check form-group mb-1'>
                  <div className='checkBox' onChange={(e) => handChange(e)} >
                    <img className="checkBox" src={checkBoxValidationForJustConfirm('flxAgree_C')} alt="" />
                    <input value={flxAgree_C} onChange={(e) => { handChange(e); analyticsCheckBoxClickEvent(e); }} name='flxAgree_C' type="checkbox" className="form-check-input" id='flxAgree_C' />

                    <label
                      className="form-check-label text-justify"
                      htmlFor='flxAgree_C'
                      style={{ fontFamily: 'proxima-nova', fontWeight: '400', lineHeight: 1.2, cursor: 'pointer' }}
                    >
                      {DocumentAgreeLabel && parse(DocumentAgreeLabel)}
                    </label>
                  </div>

                  <p className="error-message text-left mb-2 mt-1">
                    {flxAgree_c_Error &&
                      <span className="app-error-message" style={{ color: 'Red' }}>
                        {flxAgree_c_Error}</span>
                    }
                  </p>
                </div>

                <div className='form-check form-group mb-1'>
                  <div className='checkBox' onChange={(e) => handChange(e)} >
                    <img className="checkBox" src={checkBoxValidationForJustConfirm('flxDocumentAgree_C')} alt="" />
                    <input value={flxDocumentAgree_C} onChange={(e) => { handChange(e); analyticsCheckBoxClickEvent(e); }} name='flxDocumentAgree_C' type="checkbox" className="form-check-input" id='flxDocumentAgree_C' />
                    <label
                      className="form-check-label text-justify"
                      htmlFor='flxDocumentAgree_C'
                      style={{ fontFamily: 'proxima-nova', fontWeight: '400', lineHeight: 1.2, cursor: 'pointer' }}
                    >
                      {AgreeLabel && parse(AgreeLabel)}
                    </label>
                  </div>

                  <p className="error-message text-left mb-2 mt-1">
                    {flxDocumentAgree_c_Error &&
                      <span className="app-error-message" style={{ color: 'Red' }}>
                        {flxDocumentAgree_c_Error}</span>
                    }
                  </p>
                </div>

                <div className='form-check form-group mb-1'>
                  <div className='checkBox' onChange={(e) => handChange(e)} >
                    <img className="checkBox" src={checkBoxValidationForJustConfirm('flxContactAgree_C')} alt="" />
                    <input value={flxContactAgree_C} name='flxContactAgree_C'
                      type="checkbox" onChange={(e) => handChange(e)}
                      className="form-check-input" id='flxContactAgree_C' />
                    <label
                      className="form-check-label text-justify"
                      htmlFor='flxContactAgree_C'
                      style={{ fontFamily: 'proxima-nova', fontWeight: '400', lineHeight: 1.2, cursor: 'pointer' }}
                    >
                      {contactDocumentAgree && parse(contactDocumentAgree)}
                    </label>

                  </div>

                  <p className="error-message text-left mb-2 mt-1">
                    {flxContactAgree_C_Error &&
                      <span className="app-error-message" style={{ color: 'Red' }}>
                        {flxContactAgree_C_Error}</span>
                    }
                  </p>
                </div>
              </div>

            </div>

            <div className='modal-footer mt-0 mb-0 mx-0'>
              <button type="button" className="btn btn-warning btn-fill"
                disabled={!(flxAgree_C && flxDocumentAgree_C && flxContactAgree_C)}

                onClick={() => {
                  window.$('#userNoteShowModel').modal('hide')
                  applicationSubmit().catch(error => console.error(error))
                }}

              >
                Continue and Submit
              </button>
              {/* </div>
                  <div className="modal-footer mt-0 mb-0 mx-0"> */}
              <button type="button" className="btn btn-warning btn-outline"
                onClick={() => {
                  handleAmendButtonlick();
                  scrollToFirstSection();
                  window.$('#userNoteShowModel').modal('hide')
                  analyticsClickEvent('go_back_and_amend_button', '')
                  frontEndLogs('go_back_and_amend_button_clicked', false, 200, 'userNoteShowModel').catch(error => console.error(error));
                }}>
                Go Back and Amend
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

UserNoteShowModal.propTypes = {
  amountRequested: PropTypes.string,
  saveIncomeData: PropTypes.string,
  saveexpendituredata: PropTypes.string,
  DocumentAgreeLabel: PropTypes.string,
  AgreeLabel: PropTypes.string,
  contactDocumentAgree: PropTypes.string,
  allUserData: PropTypes.any,
  repayMentTerm: PropTypes.any,
  flxAgree_C: PropTypes.bool,
  flxDocumentAgree_C: PropTypes.bool,
  flxContactAgree_C: PropTypes.bool,
  flxDocumentAgree_c_Error: PropTypes.any,
  flxContactAgree_C_Error: PropTypes.any,
  checkBoxValidationForJustConfirm: PropTypes.func,
  handChange: PropTypes.func,
  analyticsCheckBoxClickEvent: PropTypes.func,
  applicationSubmit: PropTypes.any,
  handleAmendButtonlick: PropTypes.func,
  flxAgree_c_Error: PropTypes.any,
  scrollToFirstSection: PropTypes.func,
}